import ClippableTrackAsset, {
  ClippableTrackAssetProps,
} from './ClippableTrackAsset';

export default ClippableTrackAsset;
export { ClippableTrackAssetProps };

export {
  default as useClippableTrackAsset,
  UseClippableTrackAssetProps,
} from './useClippableTrackAsset';
